module.exports = __webpack_public_path__ + "static/media/395JamesPBrawleyDrNW_2018-06-11_163.97381665.jpg";